var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoint3Icon14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "point3icon1-4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.126,
    height: 96.731,
    viewBox: "0 0 66.126 96.731",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_71",
    "data-name": "\\u9577\\u65B9\\u5F62 71",
    width: 66.126,
    height: 96.731,
    fill: "#5f7cae"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_65",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 65",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_92",
    "data-name": "\\u30D1\\u30B9 92",
    d: "M11.993,12.5c.079-1.685.08-3.187.233-4.673A8.631,8.631,0,0,1,20.567.059q12.457-.122,24.916,0a8.627,8.627,0,0,1,8.422,7.882c.133,1.429.021,2.881.021,4.56,1.225,0,2.212-.009,3.2,0a8.775,8.775,0,0,1,8.916,8.212c.05.563.071,1.131.071,1.7q.005,32.184.013,64.367c0,2.738-.529,5.238-2.539,7.254a8.567,8.567,0,0,1-6.231,2.69q-24.256.023-48.511,0A8.718,8.718,0,0,1,.108,88.73C.034,87.981.014,87.224.014,86.47Q.007,54.569,0,22.669c0-2.581.346-5.015,2.131-7.035A8.805,8.805,0,0,1,8.925,12.5c.992-.008,1.985,0,3.068,0M60.445,54.561q0-16.043,0-32.087c0-3.286-1.033-4.314-4.257-4.315q-23.121,0-46.243,0c-3.22,0-4.254,1.031-4.255,4.316q-.012,32.087,0,64.174c0,3.473.984,4.411,4.541,4.411q22.838,0,45.677,0c3.607,0,4.539-.937,4.541-4.6q.008-15.949,0-31.9",
    transform: "translate(0 0)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_93",
    "data-name": "\\u30D1\\u30B9 93",
    d: "M47.691,100.944c-3.965,0-7.662-.03-11.359.015-1.407.017-2.937-.119-3.3-1.548a4.953,4.953,0,0,1,.614-3.6c6.608-9.637,13.345-19.185,20.039-28.763.914-1.307,1.945-2.414,3.724-1.832,1.748.572,2.011,2.029,2.005,3.647-.023,5.974-.008,11.949-.008,17.924v2.455c3.881,0,7.573.035,11.264-.017,1.476-.021,3.066.114,3.445,1.627a5,5,0,0,1-.714,3.609c-6.576,9.583-13.276,19.08-19.932,28.607-.907,1.3-1.914,2.47-3.693,1.938-1.847-.552-2.1-2.084-2.1-3.774.029-5.912.011-11.824.01-17.736v-2.548m5.667,11.51.511.114L66.213,94.9c-2.273,0-4.093,0-5.914,0-4.2-.011-6.5-2.264-6.555-6.5-.042-3.078,0-6.158-.018-9.236,0-.5-.1-1.008-.207-1.965L40.886,95.281c2.4,0,4.346-.017,6.292.01a7.307,7.307,0,0,1,1.854.221c2.775.778,4.27,2.849,4.315,6.084.05,3.619.011,7.238.011,10.858",
    transform: "translate(-20.485 -40.481)",
    fill: "#5f7cae"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint3Icon14);
export default __webpack_public_path__ + "static/media/point3icon1-4.ed21b0243a7e8e8c8414cb1188f834e4.svg";
export { ForwardRef as ReactComponent };